import React from "react";
import { Box, Icon } from "@chakra-ui/react";

export function WalletIcon() {
  return (
    <Icon boxSize={12} viewBox="0 0 256 256">
      <path fill="none" d="M0 0h256v256H0z" />
      <Box
        as="path"
        fill="new.green.150"
        d="M40 192a16 16 0 0 0 16 16h160a8 8 0 0 0 8-8V88a8 8 0 0 0-8-8H56a16 16 0 0 1-16-16Z"
        opacity={0.3}
      />
      <Box
        as="path"
        d="M40 64v128a16 16 0 0 0 16 16h160a8 8 0 0 0 8-8V88a8 8 0 0 0-8-8H56a16 16 0 0 1-16-16h0a16 16 0 0 1 16-16h136"
        fill="none"
        stroke="new.green.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={14}
      />
      <Box as="circle" fill="new.green.500" cx={180} cy={144} r={12} />
    </Icon>
  );
}
